import React from "react";
import useLabEnteryHook from "./labEnteryHook";
import { DataGrid } from '@mui/x-data-grid';
import { labColumns } from "./labEnteryCloumns";
import "./labEnteryTable.scss";

const LabEnteryTable = () => {
    const { 
        labEnteryTableState,
        handleGetRowId, handleOnCellClick,
         } = useLabEnteryHook()

    return (
        <div className="lab-entery-table p-2">
            <div className="mt-2 ml-2">
                <h4>Lab Entery</h4>
            </div>
            <div className="lab-table mt-5">
                <DataGrid
                    className="datagrid"
                    autoHeight
                    rows={labEnteryTableState && labEnteryTableState?.length > 0 ? labEnteryTableState : []}
                    columns={labColumns}
                    pageSize={10}
                    rowsPerPageOptions={[5]}
                    disableSelectionOnClick
                    experimentalFeatures={{ newEditingApi: true }}
                    getRowId={handleGetRowId}
                    checkboxSelection={false}
                    onCellClick={(params, event) => {
                        handleOnCellClick(params, event)
                    }}
                  
                />

            </div>
        </div>
    )

}

export default LabEnteryTable;